import { Component, OnInit, Inject } from '@angular/core';
import { ReportTemplatePopupComponent } from '../../report-template-popup/report-template-popup.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';

export interface FormData {
  instancedetailid:any;
  instanceid:any;
}

@Component({
    selector: 'app-rerun-popup',
    templateUrl: './rerun-popup.component.html',
    styleUrls: ['./rerun-popup.component.scss'],
    standalone: false
})
export class RerunPopupComponent implements OnInit {

  backgroundColorButton = "";
  selectedOption: string = 'existing';
  constructor( private dialogref: MatDialogRef<ReportTemplatePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormData,
    private localStorageSettings: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackbar: MatSnackBar,
    private spinner: NgxUiLoaderService ) { }

  ngOnInit(): void {
    console.log(this.data);
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
  }

  cancel() {

    this.dialogref.close();

  }

  save(){
    if(this.selectedOption==="existing"){
      console.log("existing")
      this.spinner.start();
      this.snackbar.open("Report rerun initiated", "OK", { duration: 5000 });
       this.commonService.refreshReportsAndPushToVault(this.data.instancedetailid,this.selectedOption,this.data.instanceid).subscribe((result =>{
       
     }));
     this.spinner.stop();
    }else{
      this.spinner.start();
      this.snackbar.open("Report rerun initiated", "OK", { duration: 5000 });
       this.commonService.refreshReportsAndPushToVault(this.data.instancedetailid,this.selectedOption,this.data.instanceid).subscribe((result =>{
       
     }));
     this.spinner.stop();
    }
  this.dialogref.close();
  }

  

  optionChanged() {
    console.log('Selected Option:', this.selectedOption);
  }

}
